import { useState } from 'react';
import useCurrencyState, { useAvailableCurrencies } from './useCurrencyState';
import usePayTypeState, { useAvailablePayTypes } from './usePayTypeState';
import { isQuickChat, isTfsoftware } from 'productLine';

const getCacheKey = (prefix: string, key: string) =>
  `@${isQuickChat ? 'quickchat' : isTfsoftware ? 'tfsoftware' : 'fett'}/pay-${prefix}/${key}`;

const usePay = (namespace = 'default') => {
  const typeCacheKey = getCacheKey(namespace, 'type');
  const availableCurrencies = useAvailableCurrencies();
  const [currency, setCurrency] = useCurrencyState(typeCacheKey);
  const availablePayTypes = useAvailablePayTypes(currency);
  const [payType, setPayType] = usePayTypeState(availablePayTypes);
  const [bank, setBank] = useState<Pay.PingpongBank>('BCA');
  return {
    availablePayTypes,
    currency,
    setCurrency,
    payType,
    setPayType,
    availableCurrencies,
    bank,
    setBank,
  };
};

export default usePay;
